
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hflsJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $157f8ba37e03eaa5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $157f8ba37e03eaa5$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': "\u30AD\u30E3\u30F3\u30BB\u30EB",
    'fabric.linkPicker.button.insert': "\u633F\u5165",
    'fabric.linkPicker.button.save': "\u4FDD\u5B58",
    'fabric.linkPicker.clearLink': "\u30AF\u30EA\u30A2",
    'fabric.linkPicker.clearLinkText': "\u30C6\u30AD\u30B9\u30C8\u3092\u30AF\u30EA\u30A2",
    'fabric.linkPicker.hyperlink.searchLinkResults': "{count, plural, =0 {\u691C\u7D22\u7D50\u679C\u304C\u3042\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002} other {{count,number} \u4EF6\u306E\u691C\u7D22\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u3057\u305F\u3002}}",
    'fabric.linkPicker.linkAriaLabel': "\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\u30EA\u30F3\u30AF\u3092\u5165\u529B\u307E\u305F\u306F\u8CBC\u308A\u4ED8\u3051",
    'fabric.linkPicker.linkHelperTextAriaLabel': "\u30EA\u30F3\u30AF\u8868\u793A\u306E\u30D8\u30EB\u30D1\u30FC \u30C6\u30AD\u30B9\u30C8",
    'fabric.linkPicker.linkHelperTextLabel': "\u3053\u306E\u30EA\u30F3\u30AF\u306B\u30BF\u30A4\u30C8\u30EB\u3092\u4ED8\u3051\u308B\u304B\u8AAC\u660E\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.linkPicker.linkInvalid': "\u6709\u52B9\u306A URL \u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002",
    'fabric.linkPicker.linkLabel': "\u30EA\u30F3\u30AF",
    'fabric.linkPicker.linkPlaceholder': "\u30EA\u30F3\u30AF\u3092\u8CBC\u308A\u4ED8\u3051",
    'fabric.linkPicker.linkTextAriaLabel': "\u30EA\u30F3\u30AF\u8868\u793A\u30C6\u30AD\u30B9\u30C8",
    'fabric.linkPicker.linkTextLabel': "\u8868\u793A\u30C6\u30AD\u30B9\u30C8 (\u30AA\u30D7\u30B7\u30E7\u30F3)",
    'fabric.linkPicker.linkTextPlaceholder': "\u8868\u793A\u3059\u308B\u30C6\u30AD\u30B9\u30C8",
    'fabric.linkPicker.listTitle.recentlyViewed': "\u6700\u8FD1\u306E\u8868\u793A\u5C65\u6B74",
    'fabric.linkPicker.listTitle.results': "\u7D50\u679C",
    'fabric.linkPicker.search.error.description': "\u30DA\u30FC\u30B8\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F<a>\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3 \u30B5\u30DD\u30FC\u30C8</a>\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
    'fabric.linkPicker.search.error.heading': "\u30C7\u30FC\u30BF\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002",
    'fabric.linkPicker.search.error.retry': "\u66F4\u65B0",
    'fabric.linkPicker.search.linkAriaLabel': "\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\u5165\u529B\u3059\u308B\u3068\u3001\u4EE5\u4E0B\u306B\u5019\u88DC\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
    'fabric.linkPicker.search.linkLabel': "\u30EA\u30F3\u30AF\u3092\u691C\u7D22\u307E\u305F\u306F\u8CBC\u308A\u4ED8\u3051",
    'fabric.linkPicker.search.linkPlaceholder': "\u6700\u8FD1\u306E\u30EA\u30F3\u30AF\u3092\u691C\u7D22\u307E\u305F\u306F\u65B0\u3057\u3044\u30EA\u30F3\u30AF\u3092\u8CBC\u308A\u4ED8\u3051",
    'fabric.linkPicker.search.noResults.description': "\u5225\u306E\u691C\u7D22\u8A9E\u53E5\u3067\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    'fabric.linkPicker.search.noResults.heading': "\u691C\u7D22\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
    'fabric.linkPicker.status.submitting': "\u9001\u4FE1\u4E2D",
    'fabric.linkPicker.time.message.updated': "{time} \u306B\u66F4\u65B0",
    'fabric.linkPicker.time.message.viewed': "{time} \u306B\u95B2\u89A7",
    'fabric.linkPicker.unhandledError.description': "\u30DA\u30FC\u30B8\u3092\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'fabric.linkPicker.unhandledError.heading': "\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002"
};

});


//# sourceMappingURL=ja.931e2d18.js.map
